<button
  class="button-control"
  [ngClass]="['size-' + size, 'theme-' + theme]"
  [matTooltip]="hasTooltip ? tooltip : null"
  [matTooltipPosition]="tooltipPosition"
>
  <mat-icon class="button-control__icon">{{icon}}</mat-icon>
</button>
